import * as Yup from "yup";

import {
  ChequeClearance,
  ChequeClearanceVariables,
} from "_graphql/kek/mutation/__generated__/ChequeClearance";
import { useMatch, useNavigate, useSearch } from "react-location";

import { Cheque_status } from "_graphql/__generated__/globalTypes-kek";
import { ClearChequeForm } from "components/forms";
import { LocationGenerics } from "router/location";
import { Modal } from "components";
import { clearChequeue } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

export const chequeClearValidationSchema = Yup.object().shape({
  clearance: Yup.object().shape({
    clearance_status: Yup.mixed<Cheque_status>()
      .oneOf(Object.values(Cheque_status))
      .required("Clearance status is required"),
    cleared_date: Yup.string().required("Date cleared is required"),
    reason: Yup.string().when("clearance_status", {
      is: Cheque_status.UNCLEARED,
      then: (schema) =>
        schema.required("Reason is required when cheque is uncleared"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
});

export default function ChequeClearedContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const { params } = useMatch<LocationGenerics>();
  const searchParams = useSearch<LocationGenerics>();
  const navigate = useNavigate<LocationGenerics>();
  const [create, { loading }] = useMutation<
    ChequeClearance,
    ChequeClearanceVariables
  >(clearChequeue);

  const form = useFormik<ChequeClearanceVariables>({
    initialValues: {
      clearance: {
        clearance_status: Cheque_status.PENDING,
        cleared_date: "",
        payment_id: searchParams.id || "",
        offer_id: params.offer || "",
        reason: "",
      },
    },
    validationSchema: chequeClearValidationSchema,
    onSubmit: async (variables) => {
      await create({
        variables: variables,
      }).then(({ data }) => {
        if (data?.chequeClearance) {
          toast.success("Cheque Cleared Successfully");
          refetch?.();
          form.resetForm();
        } else {
          toast.error("Failed to clear cheque. Please try again.");
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={() => {
        setOpen(false);
        navigate({
          search(prev) {
            return {
              ...prev,
              rate: 1,
              modal: undefined,
            };
          },
        });
      }}
      title="Cheque Clearance"
      description="Update the cheque clearance status"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </>
      )}
    >
      <ClearChequeForm form={form} />
    </Modal>
  );
}
